<template>
  <font-awesome-icon
    v-if="hasFinished"
    icon="lock"
    size="lg"
    class="icon"
    @click.stop="closeEvent()"/>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  props: {
    event: {
      required: true,
      type: Object
    }
  },

  mixins: [
    MixinResultHandler
  ],

  computed: {
    hasFinished: function () {
      return this.$store.getters['event/hasFinished'](this.event)
    }
  },

  methods: {
    closeEvent: async function () {
      if (window.confirm('締め処理を行うとイベントの変更ができなくなります。')) {
        const result = await this.$store.dispatch('event/close', this.event)
        this.showSnack(result)
      }
    }
  }
}
</script>
